Auth = require 'db/auth'
OrgFeatures = require 'data/org-features'
Util = require 'lib/util'
moment = require 'moment'

module.exports = (model, reason, details) ->
  reason ?= "not specified"
  details ||= "none given"

  modelJSON = model.toJSON()
  meJSON = Auth.me().toJSON()

  product = modelJSON.paidAccount?.products?[0]

  data = {}

  data["ID"] = modelJSON.id

  if modelJSON.paidAccount?.ixSubscriber
    data['ixSubscriber'] = modelJSON.paidAccount?.ixSubscriber

  if modelJSON.displayName
    data["Organization Display Name"] = modelJSON.displayName

  if modelJSON.name
    data["Organization Name"] = modelJSON.name

  if modelJSON.fullName
    data["Full Name"] = modelJSON.fullName
  else
    data["Full Name"] = meJSON.fullName

  if modelJSON.username
    data["Username"] = modelJSON.username
  else
    data["Username"] = meJSON.username

  if modelJSON.idBoards
    data["# Boards"] = modelJSON.idBoards.length

  if modelJSON.memberships
    data["# Members"] = modelJSON.memberships.length

  if product?
    data["Next Billing Date"] = if date = modelJSON.paidAccount.billingDates?[product]
      moment(new Date(date)).locale('en').format('LL')
    else
      ""
    if OrgFeatures.isYearly(product)
      data["Interval"] = "Yearly"
    else
      data["Interval"] = "Monthly"

    data["Price"] = OrgFeatures.getPrice(product)

  data["Trello Version"] = window.TrelloVersion.replace(/\s+/g, " ")

  accountInfo = ("#{ key }: #{ value }" for key, value of data).join("\n")

  Util.bugzscout
    me: meJSON
    project: "Sales"
    area: "Cancellations"
    forceNew: 1
    description: "Cancelled Business Class - #{ data["Interval"] }\n"
    extra: """
      #{ accountInfo }

      Reason: #{ reason }

      Details:

      #{ details }
      """



// WEBPACK FOOTER //
// ./app/scripts/debug/track-cancellation.coffee